import React from "react";
import DateGeneralInput from "../../input/date-general-input";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { useComponentBackgroundColor } from "../../common/adaptive-theme-provider";
import { Typography } from "@mhome/ui";

const DateDetail1Widget = ({ widget, onValueUpdate, pattern }) => {
  const getComponentBgColor = useComponentBackgroundColor();

  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data };
    console.log("date updated", data);
    onValueUpdate(updatedWidget);
  };

  const disabled = pattern && pattern.endsWith("_R");
  const showWarning = pattern && pattern.endsWith("_W");

  return (
    <div className="w-full flex flex-col gap-2">
      {/* Date Controls Section */}
      <div
        className="flex flex-col rounded-2xl"
        style={{
          padding: "12px",
          backgroundColor: getComponentBgColor("hsl(var(--card))"),
        }}
      >
        <Typography className="mb-3 font-bold flex items-center gap-1 text-sm">
          Date
          {showWarning && (
            <SyncProblemIcon
              fontSize="inherit"
              style={{ color: "hsl(var(--warning))" }}
            />
          )}
        </Typography>

        <div className="flex items-stretch h-full w-full">
          {widget && (
            <DateGeneralInput
              valueSpec={widget}
              onChange={handleValueUpdate}
              zIndex="var(--z-index-automation-input)"
              disabled={disabled}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DateDetail1Widget;
